import {html, render} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import VNBDto from '../Verteilnetzbetreiber/VNBDto'
import EinladungDto from '../Einladung/EinladungDto'
import EinladungService from '../Einladung/EinladungService'
import EinladungColumns from '../Einladung/EinladungColumns'
import BerechtigteListService from '../../services/BerechtigteListService'
import {List} from '@isceco/widget-library2/basic-elements/List/List'
import BenutzerDto from "../Benutzer/BenutzerDto";
import BenutzerColumns from "../Benutzer/BenutzerColumns";
import BenutzerService from "../Benutzer/BenutzerService";

import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/Button/Button.js'
import '@isceco/widget-library2/basic-elements/ModalDialog/ModalDialog.js'
import '@isceco/widget-library2/basic-elements/TextInput/TextInput.js'

export default class VNBBenutzer extends WebComponent {
  static get I18N_KEYS() {
    return {
      CANCEL_BUTTON: 'base.button.cancel'
    }
  }

  static get properties() {
    return {
      verteilnetzbetreiber: {type: VNBDto}
    }
  }

  constructor() {
    super()
    this.einladungService = new EinladungService('vnb', getNavigationId())
    this.benutzerService = new BenutzerService('vnb', getNavigationId())
    this.showDialogCreateEinladung = false
    this.showDialogDeleteEinladung = false
    this.showArchivedBenutzer = false
  }

  get translationFile() {
    return './views/VNBDetail/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.all([
      this.einladungService.getBackendListUrl(),
      this.benutzerService.getBackendListUrl(),
      this.einladungService.findByEmail(this.verteilnetzbetreiber.ostralPersonEmail),
      this.benutzerService.findByEmail(this.verteilnetzbetreiber.ostralPersonEmail)
    ]).then(([einladungUrl, benutzerUrl, ostralVerantwortlicherEinladung, ostralVerantwortlicherBenutzer]) => {
      this.einladungUrl = einladungUrl
      this.benutzerUrl = benutzerUrl
      this.isOstralVerantworlicherOnboarded = ostralVerantwortlicherEinladung.length > 0 || ostralVerantwortlicherBenutzer.length > 0
    }).catch(_ => {
      this.einladungUrl = ''
      this.benutzerUrl = ''
    }).finally(() =>
      this.render()
    )
  }

  getTemplate() {
    return html`
      <isceco-title size="medium" text="${this.i18n.translate('vnb.einladung.title')}">
        <isceco-button size="small" icon="plus" variant="primary"
                       text="${this.i18n.translate('einladung.create.title')}"
                       @click="${_ => this.toggleDialogEinladungCreate(true)}"
        ></isceco-button>
      </isceco-title>
      ${this._renderEinladung()}
      <isceco-title size="medium" text="${this.i18n.translate('vnb.benutzer.title')}">
        <isceco-button size="small"
                       text="${this.i18n.translate(this.showArchivedBenutzer ? 'benutzer.archived.button.hide' : 'benutzer.archived.button.show')}"
                       icon="${this.showArchivedBenutzer ? 'eye outline slash' : 'eye outline'}"
                       @click="${_ => this.toggleArchivedBenutzer()}"
        ></isceco-button>
      </isceco-title>
      ${this._renderBenutzer()}
    `
  }

  _renderEinladung() {
    return html`
      <isceco-list id="einladung-list" identifier="einladung"
                   url="${this.einladungUrl}"
                   .listService="${BerechtigteListService}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this.toEinladungDto}"
                   .columns="${EinladungColumns.getColumns(this.einladungDeleteCallback)}"
      ></isceco-list>
      ${this._renderDialogCreateEinladung()}
      ${this._renderDialogConfirmDeleteEinladung()}
    `
  }

  _renderDialogCreateEinladung() {
    if (this.showDialogCreateEinladung) {
      return html`
        <isceco-dialog id="einladung-create-dialog"
                       header="${this.i18n.translate('einladung.create.dialog.title')}"
                       description="${this.i18n.translate('einladung.create.dialog.text')}"
                       confirm-button="${this.i18n.translate('einladung.create.dialog.submit')}"
                       cancel-button="${this.i18n.translate(VNBBenutzer.I18N_KEYS.CANCEL_BUTTON)}"
                       @submit="${e => this._handleEinladungCreate(e.detail)}"
        >
          <isceco-text-input name="email" type="email"
                             required style="padding: 10px 0"
                             value="${this.isOstralVerantworlicherOnboarded ? '' : this.verteilnetzbetreiber.ostralPersonEmail}"
                             label="${this.i18n.translate('einladung.create.dialog.input.title')}"
                             pattern-error-text="${this.i18n.translate('einladung.create.dialog.input.error')}"
          ></isceco-text-input>
        </isceco-dialog>
      `
    } else {
      return html``
    }
  }

  _renderDialogConfirmDeleteEinladung() {
    if (this.showDialogDeleteEinladung) {
      return html`
        <isceco-dialog id="delete-invitation-dialog"
                       header="${this.i18n.translate('einladung.delete.dialog.title')}"
                       description="${this.i18n.translate('einladung.delete.dialog.description')}"
                       confirm-button="${this.i18n.translate('base.button.confirm')}"
                       cancel-button="${this.i18n.translate(VNBBenutzer.I18N_KEYS.CANCEL_BUTTON)}"
                       @submit="${e => this._handleEinladungDelete(e.detail)}"
        ></isceco-dialog>
      `
    } else {
      return html``
    }
  }

  _renderBenutzer() {
    return html`
      <isceco-list id="benutzer-list" identifier="benutzer"
                   .listService="${BerechtigteListService}"
                   url="${this.benutzerUrl}"
                   .defaultFilters="${{archived: this.showArchivedBenutzer}}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this.toBenutzerDto}"
                   .columns="${BenutzerColumns.getVnbColumns(this.showArchivedBenutzer, this.benutzerDeleteCallback)}"
                   sort="nachname" order="asc"
      ></isceco-list>
      ${this._renderDialogConfirmDeleteBenutzer()}
    `
  }

  _renderDialogConfirmDeleteBenutzer() {
    if (this.benutzerToDelete) {
      return html`
        <isceco-dialog id="delete-benutzer-dialog"
                       header="${this.i18n.translate('benutzer.delete.dialog.title', this.benutzerToDelete)}"
                       description="${this.i18n.translate('benutzer.delete.dialog.description', this.benutzerToDelete)}"
                       confirm-button="${this.i18n.translate('base.button.confirm')}"
                       cancel-button="${this.i18n.translate(VNBBenutzer.I18N_KEYS.CANCEL_BUTTON)}"
                       @submit="${e => this._handleBenutzerDelete(e.detail)}"
        ></isceco-dialog>
      `
    } else {
      return html``
    }
  }

  _handleEinladungDelete = event => {
    if (event.confirmed) {
      this.einladungService.delete(this.einladungToDelete?.id)
        .then(_ => {
          send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'einladung'})
          this.einladungToDelete = null
          this.showDialogDeleteEinladung = false
          this.render()
        })
    } else {
      this.einladungToDelete = null
      this.showDialogDeleteEinladung = false
      this.render()
    }
  }

  _handleEinladungCreate = event => {
    if (!event.confirmed) {
      this.toggleDialogEinladungCreate(false)
      return
    }
    const einladungEmail = document.querySelector('#einladung-create-dialog isceco-text-input[name=email]')
    if (einladungEmail.validate()) {
      const einladung = {email: einladungEmail.getValue()}
      this.einladungService.create(einladung)
        .then(created => {
          window.showAlert(this.i18n.translate('einladung.create.alert.success', {empfaenger: created.empfaenger}), "", 'success')
          send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'einladung'})
        })
      this.toggleDialogEinladungCreate(false)
    }
  }

  _handleBenutzerDelete = event => {
    if (event.confirmed) {
      this.benutzerService.delete(this.benutzerToDelete.uuid)
        .then(_ => {
          window.showAlert(this.i18n.translate(`benutzer.delete.alert.success`, {name: this.benutzerToDelete.name}), "", 'success')
          send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'benutzer'})
        })
        .finally(_ => {
          this.benutzerToDelete = null
          this.render()
        })
    } else {
      this.benutzerToDelete = null
      this.render()
    }
  }

  einladungDeleteCallback = row => {
    this.einladungToDelete = row
    this.showDialogDeleteEinladung = true
    this.render()
  }

  toggleDialogEinladungCreate(show) {
    this.showDialogCreateEinladung = show
    this.reload()
  }

  toggleArchivedBenutzer() {
    this.showArchivedBenutzer = !this.showArchivedBenutzer
    // Update der Liste forcieren, indem wir sie zunächst löschen
    render(html``, this.root)
    this.render()
  }

  benutzerDeleteCallback = row => {
    this.benutzerToDelete = row
    this.render()
  }

  toEinladungDto = row => new EinladungDto(row)
  toBenutzerDto = row => new BenutzerDto(row)
}

customElements.define('eko-frontend-vnb-detail-benutzer', VNBBenutzer)
